import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { DentalAttendance } from "@/@types/esus/DentalAttendance";

type IndicatorEsfC3CitizenDentalAttendancesHistoryItemProps = {
	dentalAttendance: DentalAttendance;
};

export function IndicatorEsfC3CitizenDentalAttendancesHistoryItem({
	dentalAttendance,
}: Readonly<IndicatorEsfC3CitizenDentalAttendancesHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{dentalAttendance.healthTeam1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{dentalAttendance.healthUnit1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{dentalAttendance.professional1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{dentalAttendance.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
		</>
	);
}
